"use client";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import Image from "next/image";

export default function HowItWorks() {
	const t = useTranslations();

	const stepsData = [
		{
			id: 1,
			image: "/image/home/how1.webp",
			title: t("home.hd1"),
			description: "",
		},
		{
			id: 2,
			image: "/image/home/how2.webp",
			title: t("home.hd2"),
			description: "",
		},
		{
			id: 3,
			image: "/image/home/how3.png",
			title: t("home.hd3"),
			description: "",
		},
	];

	return (
		<section className="py-16" aria-labelledby="how-it-works-title">
			<div className="container mx-auto px-4">
				<header className="flex flex-col items-center gap-2">
					<h2
						id="how-it-works-title"
						className="font-queens group relative mb-4 text-center text-[32px] font-medium md:text-[42px] lg:text-[52px]"
					>
						{t("home.ht1")}
						<span className="absolute bottom-0 left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"></span>
					</h2>
				</header>

				<ol className="mb-8 grid grid-cols-1 gap-6 md:mb-12 md:grid-cols-3 md:gap-8">
					{stepsData.map((step) => (
						<li key={step.id} className="flex flex-col items-center">
							<figure className="relative mb-4 h-[200px] w-full overflow-hidden sm:h-[250px] md:mb-6 md:h-[300px] lg:h-[400px]">
								<Image
									src={step.image}
									alt={`Step ${step.id}: ${step.title}`}
									fill
									className="rounded-sm object-cover"
									sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 33vw"
								/>
							</figure>
							<figcaption className="relative flex w-full items-center justify-center gap-3">
								<h3 className="w-[300px] text-center text-xl font-medium">{step.title}</h3>
								<div
									className="absolute left-[30px] top-0 flex h-8 w-8 items-center justify-center rounded-full border border-black max-xl:hidden"
									aria-hidden="true"
								>
									<span>{step.id}</span>
								</div>
							</figcaption>
							{/* <p className="mt-2 text-center text-gray-600">{step.description}</p> */}
						</li>
					))}
				</ol>

				<footer className="text-center">
					<Link
						href="/products"
						className="group relative inline-block overflow-hidden bg-black px-8 py-3 font-medium text-white transition-all duration-300 hover:!text-white md:px-16 md:py-4"
						aria-label="Browse all products"
					>
						<span className="relative z-10">SHOP NOW</span>
						<span
							className="absolute left-0 top-0 h-full w-0 bg-main opacity-0 transition-all duration-500 ease-in-out group-hover:w-full group-hover:opacity-100"
							aria-hidden="true"
						></span>
					</Link>
				</footer>
			</div>
		</section>
	);
}
